<template>
    <b-row class="mb-1">
        <b-col
            v-for="(cmp, index) in selectComponents"
            :key="index"
            :md="cmp[1]"
            :class="{
                'pr-md-0': index < selectComponents.length - 1
            }"
        >
            <component
                :is="cmp[0]"
                :clearable="isClearable(cmp[0], cmpArr)"
                :storeKey=cmp[2]
            ></component>
        </b-col>
    </b-row>
</template>
<script>
import { computed, getCurrentInstance } from '@vue/composition-api'
import useSelectProjectAndGroup from '@/composables/useSelectProjectAndGroup'
const CommonSelectGroup = () => import('./CommonSelectGroup.vue')
const CommonSelectProject = () => import('./CommonSelectProject.vue')
const CommonSelectMonth = () => import('./CommonSelectMonth.vue')
const CommonSelectCalendarMonth = () => import('./CommonSelectCalendarMonth.vue')
const CommonSelectCalendarMonthRange = () => import('./CommonSelectCalendarMonthRange.vue')
const CommonSelectCalendarYear = () => import('./CommonSelectCalendarYear.vue')
export default {
    components: {
        CommonSelectGroup,
        CommonSelectProject,
        CommonSelectMonth,
        CommonSelectCalendarMonth,
        CommonSelectCalendarMonthRange,
        CommonSelectCalendarYear
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const selectComponentMap = {
            'month': [
                ['common-select-calendar-month', 2]
            ],
            'project-month': [
                ['common-select-project', 10],
                ['common-select-calendar-month', 2]
            ],
            'group-project-month': [
                ['common-select-group', 4],
                ['common-select-project', 6],
                ['common-select-calendar-month', 2]
            ],
            'group-project-monthrange': [
                ['common-select-group', 4],
                ['common-select-project', 6],
                ['common-select-calendar-month-range', 2, '$_costPivot']
            ],
            'group-project': [
                ['common-select-group', 6],
                ['common-select-project', 6]
            ],
            'project-year': [
                ['common-select-project', 10],
                ['common-select-calendar-year', 2, '$_invoice']
            ],
            // 이용내역서 — 그룹만 선택하면 일괄 다운로드 화면으로 전환된다.
            // 폭은 group-project-month 와 같은 4/6/2 배분을 따른다.
            'group-project-year': [
                ['common-select-group', 4],
                ['common-select-project', 6],
                ['common-select-calendar-year', 2, '$_invoice']
            ]
        }
        /**
         * 일괄 다운로드(그룹 선택)는 mzc 에만 배포된 기능이다.
         * 다른 테넌트에서 그룹 셀렉터를 노출하면 계정만 해제된 빈 화면이 되므로,
         * 해당 조합을 요구하는 라우트라도 기존 조합으로 되돌린다.
         */
        const BULK_FALLBACK = { 'group-project-year': 'project-year' }
        const bulkSupported = process.env.VUE_APP_NAMESPACE === 'mzc'

        /**
         * 그룹만 선택된 상태(=일괄 다운로드 화면)에서는 연도 셀렉터를 감춘다.
         * 연도는 단건 화면이 쓰는 값이고, 일괄 화면은 자체 기간(시작월~종료월)을
         * 갖기 때문에 둘 다 보이면 기간 선택이 두 곳에 있는 것처럼 보인다.
         */
        const isBulkMode = computed(() =>
            bulkSupported &&
            !!vm.$store.getters.selectedGroup?.groupIdx &&
            !vm.$store.getters.selectedProject?.usageAccountId)

        const resolvedSelectType = computed(() => {
            const type = vm.$route.meta.selectType
            if (!bulkSupported && BULK_FALLBACK[type]) {
                return BULK_FALLBACK[type]
            }
            if (type === 'group-project-year' && isBulkMode.value) {
                return 'group-project'
            }
            return type
        })
        const selectComponents = computed(() => selectComponentMap[resolvedSelectType.value])
        const cmpArr = computed(() => selectComponents.value?.map(cmp => cmp[0]) || [])
        const { isClearable } = useSelectProjectAndGroup()
        return {
            selectComponents,
            isClearable,
            cmpArr
        }
    }
}

</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
